import { DonutIcon } from '@carboncopyco/icons';
import type { IDynamicEditData } from '@carboncopyco/types';
import { ModificationItem } from './ModificationItem';
import { getChartLabel } from './utils';

export const ChartModificationItem = ({
  edit,
}: {
  edit: IDynamicEditData['element'];
}) => {
  return (
    <ModificationItem>
      <ModificationItem.Content>
        <ModificationItem.Icon>
          <DonutIcon size={18} />
        </ModificationItem.Icon>
        <ModificationItem.Text label={getChartLabel(edit)} />
      </ModificationItem.Content>
    </ModificationItem>
  );
};
